import { types } from 'mobx-state-tree';

export const EnvStore = types
  .model('Env', {
    userAgentType: types.optional(types.enumeration('UserAgentType', ['desktop', 'mobile']), 'desktop'),
    screen: types.optional(types.enumeration('Screen', ['desktop', 'tablet', 'mobile']), 'desktop'),
  })
  .actions(self => ({
    setUserAgentType: userAgentType => {
      self.userAgentType = userAgentType;
    },

    setScreen: screen => (self.screen = screen),
  }))
  .views(self => ({
    isUserAgentDesktop: () => self.userAgentType === 'desktop',

    isUserAgentMobile: () => self.userAgentType === 'mobile',

    isScreenDesktop: () => self.screen === 'desktop',

    isScreenTablet: () => self.screen === 'tablet',

    isScreenMobile: () => self.screen === 'mobile',
  }));

export default EnvStore;



// WEBPACK FOOTER //
// ./src/stores/EnvStore.js